var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M7 0.70166C3.13 0.70166 0 3.36889 0 6.66671C0 8.14946 0.5 9.53846 1.41 10.7911C2.36 12.1034 3.61 13.2283 4.57 14.5406C5.04 15.1797 5.38 15.7762 5.74 16.4664C6 16.9351 6.21 17.7447 7 17.7447C7.79 17.7447 8 16.9351 8.25 16.4664C8.62 15.7762 8.95 15.1797 9.42 14.5406C10.38 13.2368 11.63 12.112 12.58 10.7911C13.5 9.53846 14 8.14946 14 6.66671C14 3.36889 10.87 0.70166 7 0.70166ZM7 9.01013C5.62 9.01013 4.5 8.05572 4.5 6.87975C4.5 5.70378 5.62 4.74937 7 4.74937C8.38 4.74937 9.5 5.70378 9.5 6.87975C9.5 8.05572 8.38 9.01013 7 9.01013Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.c18d207e40c9db8192d0dca5a69618f6.svg";
export { ForwardRef as ReactComponent };